import { render, staticRenderFns } from "./adminaudit.vue?vue&type=template&id=061ba64c&scoped=true"
import script from "./adminaudit.vue?vue&type=script&lang=js"
export * from "./adminaudit.vue?vue&type=script&lang=js"
import style0 from "./adminaudit.vue?vue&type=style&index=0&id=061ba64c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061ba64c",
  null
  
)

export default component.exports